
import { CircularProgress, FormControlLabel, IconButton, Switch, Tooltip } from "@mui/material"
import { useDispatch } from "react-redux";
import { useState } from "react";
import { callApiAction } from "../../../store/actions/commonAction";
// import { updateUserState } from "../../../apis/user.api";
import { updateUserHiddenState } from "../../../apis/user.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../../utils/constants";

const UpdateHiddenUserButton = ({ params, setParams }) => {

    const [loading, setLoading] = useState(false)
    const [invisible, setInvisible] = useState(params.hidden)

    const dispatch = useDispatch()


    const onStatusChange = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await updateUserHiddenState({ userId: params._id }),
                (response) => {

                    setLoading(false);
                    setInvisible(!invisible)
                    dispatch(callSnackBar("User status changed.", SNACK_BAR_VARIETNS.suceess))
                },
                (err) => {
                    setLoading(false);
                    dispatch(callSnackBar("User status cant be changed.", SNACK_BAR_VARIETNS.error))
                }
            )
        );
    };
    return <>
        {loading ? <CircularProgress /> :
            <FormControlLabel
                sx={{
                    display: "block",
                }}
                control={
                    <Switch
                        checked={invisible}
                        value
                        name="loading"
                        color="primary"
                        onClick={(e) => {
                            onStatusChange();
                        }}
                    />
                }
            />}
    </>
}
export default UpdateHiddenUserButton;